import { defineMessages } from "react-intl";

/** Section-level strings: page titles the views own, and the delete dialog. */
export const sectionMessages = defineMessages({
  sectionTitle: {
    id: 'Dx7Eo/',
    defaultMessage: "Product Series",
    description: "product series section, title and sidebar entry",
  },
  createSeriesTitle: {
    id: 'IFC+sB',
    defaultMessage: "Create product series",
    description: "series create, page title",
  },
  seriesDeleteTitle: {
    id: 'E6t5PY',
    defaultMessage: "Delete product series",
    description: "series detail, dialog title",
  },
  seriesDeleteContent: {
    id: 'EeNPAq',
    defaultMessage: "Delete {name}? Its products are left alone.",
    description: "series detail, dialog content",
  },
});

/** Live or Draft on the series list. */
export const statusMessages = defineMessages({
  live: {
    id: 'ibyYdX',
    defaultMessage: "Live",
    description: "series list status pill",
  },
  draft: {
    id: 'LVUhu3',
    defaultMessage: "Draft",
    description: "series list status pill",
  },
});
